/* eslint-disable import/no-cycle */

import { imageFile } from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

import ItemPrice from './ItemPrice';
import Modifiers from './Modifiers';
import EventItemData from './itemData/EventItemData';
import GiftCardItemData from './itemData/GiftCardItemData';

const Item = (props) => {
  const { item, settings } = props;
  if (item.purchaseType === 'Pickup To Ship' && item.quantity < 0) {
    return null;
  }
  return (
    <div>
      <div className="c7-cart-items__quantity">{item.quantity}</div>
      <div className="c7-cart-items__image">
        <img src={imageFile(item.image, 'small')} alt={item.productTitle} />
      </div>
      <div className="c7-cart-items__title">
        {item.productTitle}
        <div className="c7-cart-items__title__variant">
          {item.productVariantTitle}
        </div>
        <Modifiers item={item} />
        <EventItemData item={item} />
        <GiftCardItemData item={item} />
      </div>
      <ItemPrice item={item} settings={settings} />
      {item.purchaseType === 'Pickup To Ship' && (
        <div className="c7-cart-items__item-total">-</div>
      )}
      {item.purchaseType !== 'Pickup To Ship' && (
        <div className="c7-cart-items__item-total">
          {currencyFormat(item.price * item.quantity, settings)}
        </div>
      )}
    </div>
  );
};

export default Item;
